import React from 'react';
import { Tabs } from 'antd';
import AvisInformacioAddicionalComentaris from './avisInformacioAddicionalComentaris';
import AvisInformacioAddicionalMonitoritzacio from './avisInformacioAddicionalMonitoritzacio';

const TabPane = Tabs.TabPane;

const AvisInformacioAddicional = () => {

    return (
        <Tabs defaultActiveKey='1' type='card'>
            <TabPane tab='Comentaris' key='1'>
                <AvisInformacioAddicionalComentaris />
            </TabPane>
            <TabPane tab='Teledetecció' key='2'>
                <AvisInformacioAddicionalMonitoritzacio />
            </TabPane>
        </Tabs>
    );
};

export default AvisInformacioAddicional;



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicional.js